import { Component, ElementRef, EventEmitter, Output, Signal, ViewChild } from '@angular/core';
import { EmailApiService } from '../../../services/email-api.service';
import { EmailApiRequest } from '../../../types/email-api.types';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { signal } from '@angular/core';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { ButtomLogoComponent } from '../../../shared/buttom-logo/buttom-logo.component';

enum CreateState {
  Begin,
  Sent,
}

interface EmailForm {
  email: FormControl<string>;
  taC: FormControl<boolean>;
}

const RESEND_SECONDS = 45;

@Component({
  selector: 'app-create-3',
  imports: [ReactiveFormsModule, NgSwitch, NgSwitchCase, ButtomLogoComponent],
  templateUrl: './create-3.component.html',
  styleUrl: './create-3.component.css',
})
export class Create3Component {
  @Output() stepChange = new EventEmitter<number>();
  @ViewChild('emailInput') emailInput!: ElementRef;

  emailForm: FormGroup<EmailForm>;

  CreateState = CreateState;
  currentCreateState = signal(CreateState.Begin);

  isResendEnabled = signal(false);
  isEmailInputReadOnly = signal(false);

  timerRemainingSeconds = signal(RESEND_SECONDS);
  private resendTimerId: ReturnType<typeof setTimeout> | null = null;
  private resendIntervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private emailApiService: EmailApiService) {
    this.emailForm = new FormGroup<EmailForm>({
      email: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
      taC: new FormControl(false, {
        nonNullable: true,
        validators: [Validators.requiredTrue],
      }),
    });
  }

  updateRemainingSeconds() {
    const newTime = this.timerRemainingSeconds() - 1;
    this.timerRemainingSeconds.set(newTime);

    if (newTime <= 0) {
      clearInterval(this.resendIntervalId!);
    }
  }

  resendTimerExpired() {
    clearInterval(this.resendIntervalId!);
    this.isResendEnabled.set(true);
  }

  startResendTimer() {
    if (this.resendTimerId) {
      clearTimeout(this.resendTimerId);
    }
    if (this.resendIntervalId) {
      clearInterval(this.resendIntervalId);
    }

    this.timerRemainingSeconds.set(RESEND_SECONDS);
    this.isEmailInputReadOnly.set(true);
    this.isResendEnabled.set(false);

    this.resendIntervalId = setInterval(
      () => this.updateRemainingSeconds(),
      1000
    );

    this.resendTimerId = setTimeout(
      () => this.resendTimerExpired(),
      RESEND_SECONDS * 1000
    );
  }

  sendApiRequest() {
    console.log('Create3Component: sendApiRequest', this.emailForm.value);

    const email: EmailApiRequest = {
      publisherId: '45628',
      userId: '123',
      userEmail: this.emailForm.value.email!,
    };

    this.emailApiService.createDisposableEmail(email).subscribe({
      next: (data) => {
        console.debug('Create3Component: handleSend response', data);
      },
      error: (err) => {
        console.error('Create3Component: handleSend error', err);
      },
    });
  }

  handleSubmit() {
    if (this.emailForm.invalid) {
      console.warn(
        'Create3Component: handleSubmit invalid form',
        this.emailForm.errors
      );
      return;
    }

    this.sendApiRequest();

    this.currentCreateState.set(CreateState.Sent);
    this.startResendTimer();
  }

  handleToggleEditEmailInput() {
    this.isEmailInputReadOnly.set(!this.isEmailInputReadOnly());
    if (!this.isEmailInputReadOnly()) {
      this.emailInput.nativeElement.focus();
    }
  }
}
